import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { appSettings, loadAppSettingsAsync } from './AppSettings';
import App from './Components/App';
import apiClient from './Services/ApiClient';
import { userSettingsStore } from './Services/UserSettingsStore';
import { attachConsole } from './Utils';
import "./Index.scss";

async function runAsync() {

    window.addEventListener("error", er => {
        console.error("UNHANDLED: ", er);
    });

    window.addEventListener("unhandledrejection", er => {

        console.error("UNHANDLED ASYNC: ", er.reason);
        console.error(er.reason.stack);
    });

    await loadAppSettingsAsync();

    console.log(appSettings);

    if (appSettings.debugMode)
        attachConsole();

    await userSettingsStore.loadAsync();

    apiClient.open(appSettings.apiUrl, appSettings.accessToken);

    const root = createRoot(document.getElementById('root'));

    root.render(
        <HashRouter>
            <App />
        </HashRouter>
    );
}

runAsync();